import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MuiDialogActions from '@mui/material/DialogActions';

import { useTheme } from '@mui/material/styles';

const DialogActions = MuiDialogActions;

const ConfirmationModal = (props) => {
  const {
    open,
    onSubmit,
    onClose,
    onSave,
  } = props;

  const theme = useTheme();

  const classes = {
    paper: { width: '450px' },
    primary: { color: theme.palette.primary.main },
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.paper }}
      PaperProps={{
        sx: (theme) => ({
          backgroundColor: 'var(--color-surface-elevated)',
          color: theme.palette.text.primary,
          border: `1px solid ${theme.palette.divider}`,
        }),
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
        Submit or Save Alignment Data?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" style={{ textAlign: 'center' }}>
          Please click Save to store this data and submit later, otherwise click Submit to complete this step
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={(theme) => ({ borderTop: `1px solid ${theme.palette.divider}` })}>
        <div className="d-flex flex-1">
          <div
            className={`${classes.primary} flex-1 p-md text-center pointer font-bold`}
            style={{ borderRight: `1px solid ${theme.palette.divider}`, color: theme.palette.primary.main }}
            onClick={onSave}
          >
            Save
          </div>
          <div
            className={`${classes.primary} flex-1 p-md text-center pointer font-bold`}
            style={{ color: theme.palette.primary.main }}
            onClick={onSubmit}
          >
            Save & Submit
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
